//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import reportSpecies from '~/graphql/queries/reportSpecies';
import customerReportSpecies from '~/graphql/queries/customerReportSpecies';
import reportSiblings from '~/graphql/queries/reportSiblings.gql';
import deleteReportSpecies from '~/graphql/mutations/deleteReportSpecies';
import {REPORT_SPECIES_TYPES} from '~/plugins/constants';

export default {
  auth: false,
  apollo: {
    reportSpecies: {
      query: reportSpecies,
      variables() {
        return {
          uuid: this.$route.params.uuid,
          query: this.speciesSearch,
          type: this.speciesType,
        };
      },
      skip({$nuxt}) {
        return !$nuxt.$auth.loggedIn;
      },
    },
    customerReportSpecies: {
      query: customerReportSpecies,
      variables() {
        return {
          uuid: this.$route.params.uuid,
          query: this.speciesSearch,
          type: this.speciesType,
          access_token: this.$route.query.t,
        };
      },
      result(data) {
        if (data?.data?.customerReportSpecies) {
          this.reportSpecies = data.data.customerReportSpecies;
          this.loaded = true;
        }
      },
      error() {
        this.$nuxt.error({statusCode: 401});
      },
      skip({$nuxt}) {
        return $nuxt.$auth.loggedIn;
      },
    },
    reportSiblings: {
      query: reportSiblings,
      variables() {
        return {
          uuid: this.$route.params.uuid,
          access_token: this.$route.query.t,
        };
      },
    },
  },
  data: () => ({
    reportSpecies: [],
    reportSiblings: [],
    speciesSearch: '',
    speciesType: '',
    addingSpecies: false,
    isSent: false,
    REPORT_SPECIES_TYPES,
  }),
  computed: {
    speciesTypes() {
      const types = [{value: '', label: 'Alle'}];

      for (const [key, value] of Object.entries(REPORT_SPECIES_TYPES)) {
        types.push({value: key, label: value});
      }

      return types;
    },
  },
  methods: {
    addSpecies(species) {
      this.reportSpecies.unshift(species);
      this.$refs.adminOverview.getReport(true);
    },
    async deleteSpecies(index) {
      const species = this.reportSpecies[index];
      if (!confirm('Weet je zeker dat je "' + species.title + '" wilt verwijderen?')) {
        return;
      }

      try {
        await this.$apollo.mutate({
          mutation: deleteReportSpecies,
          variables: {
            uuid: species.uuid,
          },
        }).then(() => {
          this.reportSpecies.splice(index, 1);
          this.$toast.success('Soort is succesvol verwijderd.');
          this.$refs.adminOverview.getReport(true);
        });
      } catch (e) {
        this.$toast.error(e);
      }
    },
    setIsSent(isSent) {
      this.isSent = isSent;
    },
  },
};
